import React from 'react';
import ModuleEditBlock from '../Step2/Module/Edit/Block';
import { Button } from '../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../components/Common/Icons/Icons';
import DatePickerWithRange from '../../../../../../components/Common/UI/DateRange';
import { useMessageManagerProvider } from '../../../../../context/messageManager';

function BuilderStepFour() {
  const { state, handleDispatch } = useMessageManagerProvider();

  const handleDateChange = (from?: Date, to?: Date) => {
    handleDispatch({
      step4: {
        startDate: from ?? state.step4.startDate,
        endDate: to ?? state.step4.endDate,
      },
    });
  };

  return (
    <div className="bg-white shadow-lg max-w-[465px] border p-[30px] mx-auto self-center grid gap-y-[25px]">
      <div className="font-bold text-xl text-primary">Select status of message</div>
      <ModuleEditBlock title="Scheduled for" subTitle="Schedule a processing date or save it as draft" className="p-0">
        <DatePickerWithRange from={state.step4.startDate} to={state.step4.endDate} handleOnChange={handleDateChange} />
      </ModuleEditBlock>
      <div className="rounded-lg border text-primary bg-[#5582B42E] p-[10px]">
        <div className="font-bold mb-[5px]">Note:</div>
        The date should match the date numbers (mm/dd/yy) in the filename date.
      </div>
      <div className="flex justify-end">
        <Button variant="outline" className="!border-addition5 !text-white !bg-addition5 p-[10px_15px]">
          <div className="flex items-center justify-center bg-white p-[2px] rounded-full w-[20px] h-[20px] mr-[5px]">
            <Icons.Check className="[&_path]:fill-addition5 w-[10px]" />
          </div>
          Approve Campaign
        </Button>
      </div>
    </div>
  );
}

export default BuilderStepFour;
